import React from 'react';
import { Card } from "react-bootstrap";
import face_bence_agg from "../../assets/img/face_bence_agg.png";
import face_oliver_balogh from "../../assets/img/face_oliver_balogh.png";
import ShowMoreText from "react-show-more-text";
import proj_protein_protein from "../../assets/img/proj_protein_protein.png";

const O_Balogh_and_B_Agg_protein = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_protein_protein} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_oliver_balogh}
              
            />{" "}
            <p className="text7">Olivér Balogh</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_bence_agg}
              
            />{" "}
            <p className="text7">Bence Ágg</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Bioinformatics Laboratory, Department of Pharmacology and Pharmacotherapy, Semmelweis University</p>
            </div>
            
            <div>
            Mechanisms of the living cell are mediated by proteins and their interactions, marking them 
            as a crucial component in the understanding of cellular functions and drug pathways. Such a 
            complex system can be represented as an interaction network, called the interactome, with 
            proteins being the nodes and the known protein-protein interactions (PPIs) being the edges. 
            A central problem of this field is that many of the PPIs remain unknown due to the cost of 
            experimentally validating their existence. As such, predictive models are in demand to determine 
            the most probable interactions for validation. Given a network-based representation of the 
            known PPIs, this task is transformed into a biologically motivated link-prediction problem, 
            which we previously tackled with a conditional generative adversarial network (cGAN) machine 
            learning model, treating regions of the network as images in an image-to-image translation 
            framework. The aim of this project is to develop the next iteration of this model, expanding 
            it with neural network architectures from the state of the art models of computer vision and 
            natural language processing. The tasks encompass basic data processing steps, the implementation, 
            training and optimization of generative models, the evaluation of the results, and the 
            accompanying literature search. The project offers an opportunity to gain insights into the 
            application of AI in molecular biology research, and experience with the challenges of AI 
            engineering. Students are expected to have a general understanding of the fundamentals of 
            neural networks and machine learning, as well as of the Python programming language.
            <br/>
            <br/>
            Related literature:
            <ul>
             <li><a href="https://doi.org/10.1186/s12859-022-04598-x">Balogh et al. 
            (2022). Efficient link prediction in the protein–protein interaction network using topological 
            information in a generative adversarial network machine learning model. BMC Bioinformatics.</a></li>
            </ul>
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default O_Balogh_and_B_Agg_protein;